module.exports = __webpack_public_path__ + "static/media/trafficAnalysis.mobile.dea497b9.svg";